<template>
  <section>
    <h3>Payment Record</h3>
    <template v-if="Array.isArray(form)">
      <section
        v-for="(item, index) in formData"
        :key="index">
        <!-- <span class="title">
        Policy Period
        <span class="date">{{ item.period }}</span>
      </span> -->
        <div class="transparent">
          <el-table
            :data="item.record"
            stripe
            style="width: 100%">
            <el-table-column
              prop="type_language"
              label="Type"></el-table-column>
            <el-table-column label="Transaction Date">
              <template #default="{row}">
                <div class="time-flex">
                  <span>{{row.success_at.split(" ")[0]}}</span>
                  <span>{{row.success_at.split(" ")[1]}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="method"
              label="Method"></el-table-column>
            <el-table-column
              prop="amount"
              label="Amount"></el-table-column>
            <el-table-column
              prop="holder"
              label="Card Holder"></el-table-column>
            <el-table-column
              prop="number"
              label="Reference No."></el-table-column>
            <el-table-column
              label="Proof">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.proof"
                  class="link"
                  @click="openFile(scope.row.proof.file_url)">{{ scope.row.proof.file_name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="Remark">
            </el-table-column>
          </el-table>
        </div>
      </section>
    </template>

    <template v-else>
      <div class="transparent">
        <el-table
          :data="formData"
          stripe
          style="width: 100%">
          <el-table-column
            prop="success_at"
            label="Transaction Date">
          </el-table-column>
          <el-table-column
            prop="method"
            label="Method"></el-table-column>
          <el-table-column
            prop="amount"
            label="Amount"></el-table-column>
          <el-table-column
            prop="holder"
            label="Account Holder"></el-table-column>
        </el-table>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'PaymentRecord',
  props:{
    form:{
      type: [Array, Object],
    }
  },
  data(){
    return{
      formData: null
    }
  },
  watch:{
    form:{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          if(!Array.isArray(val)){
            this.formData = Array(val)
            return
          }
        }
        this.formData = val
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.time-flex{
  display: flex;
  flex-direction: column;
}
</style>
